module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-4 p-sm-3 col-md-8"
  }, [_c('h1', [_vm._v("撮影会／イベント／教室 " + _vm._s(_vm.titleText))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-5",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirm()
      }
    }
  }, [_c('div', {
    staticClass: "form-group p-3"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.event_kind),
      expression: "event_kind"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "PhotoParking",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.event_kind = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選んで下さい...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "photo"
    }
  }, [_vm._v("撮影会")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "event"
    }
  }, [_vm._v("イベント")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "school"
    }
  }, [_vm._v("教室")])]), _vm._v(" "), (_vm.validation.event_kind) ? _c('p', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.validation.event_kind))]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c(_vm.selectedForm, {
    tag: "div",
    attrs: {
      "validation": _vm.validation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('a', {
    staticClass: "btn btn-secondary btn-lg",
    class: _vm.preserveButtonStyle,
    attrs: {
      "formnovalidate": ""
    },
    on: {
      "click": function($event) {
        _vm.preserve()
      }
    }
  }, [_vm._v("下書き保存")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("入力内容確認")])]), _vm._v(" "), _c('div', {
    staticClass: "attention text-left my-2"
  }, [_vm._v("事務局承認後に掲載となります。(通常中3営業日)")])]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "attention"
  }, [_vm._v("※")]), _vm._v("必須")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "PhotoParking"
    }
  }, [_vm._v("カテゴリ"), _c('span', {
    staticClass: "attention"
  }, [_vm._v("※")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("撮影会：講師主催のもの。規定料金以上。"), _c('br'), _vm._v("イベント：企業、団体主催のもの。（体験会等）"), _c('br'), _vm._v("教室：6回、3回コースの教室。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-604ec941!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/InputRoot.vue
// module id = 342
// module chunks = 1